<template>
  <div id="terms" class="l-contents l-terms">
    <h1 class="l-pageTitle">労務監査クラウドサービス　労務サプリ 利用規約</h1>
    <h2>第1章　総則</h2>
    <h3>第1条（利用規約の適用）</h3>
    <div class="l-terms__block">
      <p class="l-terms__indent">1. この利用規約（以下「本規約」といいます。）は、利用者（第2条に定義します。）が、株式会社全国労務診断協会（以下「当社」といいます。）が「労務監査クラウドサービス 労務サプリ」と称して提供するサービス（以下「本サービス」といいます。）を利用するための条件および利用者と当社の間の法律関係を定めることを目的とします。</p>
      <p class="l-terms__indent">2. 利用者は、本規約を遵守して本サービスを利用するものとし、本規約に同意できない場合、本サービスの利用はできません。利用者が本サービスを利用したときは、本規約に同意したものとみなされるものとします。</p>
    </div>

    <h3>第2条（用語の定義）</h3>
    <div class="l-terms__block">
      <p>本規約において用いる以下の各用語は、それぞれ以下に定める意味を有します。</p>
      <p class="l-terms__indent2">
        （1）OSアカウント<br>
        契約者（または顧客）が本サービスを利用するために、当社が契約者に付与する（または契約者が顧客に付与する）サーバ上で稼働するOSへログインするためのユーザIDおよびパスワードをいいます。
      </p>
      <p class="l-terms__indent2">
        （2）AWS<br>
        本サービスの一部を構成する、Amazon Web Services, Inc.（以下「AWS 社」といいます。）が提供するクラウドサービスをいいます。
      </p>
      <p class="l-terms__indent2">
        （3）AWS 利用規約<br>
        AWS 社が定める以下の規約および条件（変更後を含みます。）ならびにAWS社が同社のWeb サイト上で適宜定めるAWSの利用に関する条件、ガイドライン等をいいます。<br>
        <span class="l-terms__list">・Amazon Web Services 適正利用規約 <a href="http://aws.amazon.com/jp/aup/" target="_blank">http://aws.amazon.com/jp/aup/</a></span><br>
        <span class="l-terms__list">・AWS カスタマーアグリーメント <a href="http://aws.amazon.com/jp/agreement/" target="_blank">http://aws.amazon.com/jp/agreement/</a></span><br>
        <span class="l-terms__list">・AWS サービス条件 <a href="http://aws.amazon.com/jp/serviceterms/" target="_blank">http://aws.amazon.com/jp/serviceterms/</a></span><br>
      </p>

      <p class="l-terms__indent2">
        （4）契約者<br>
        本規約第5条に従い、当社との間で利用契約を締結した者をいいます。
      </p>
      <p class="l-terms__indent2">

        （5）顧客<br>
        契約者の顧客であって、本規約第12条に従い、契約者からOSアカウントを付与され、本サービスを利用することができる者（日本国内の法人または個人事業主に限られます。）をいいます。なお、顧客には、本規約第2章の各規定は適用されません。
      </p>
      <p class="l-terms__indent2">
        （6）利用者<br>
        本規約およびAWS利用規約に同意の上、当社の本サービスを利用する者をいい、契約者と顧客を含みます。
      </p>
      <p class="l-terms__indent2">
        （7）利用契約<br>
        本規約第5条に従い、契約者と当社の間で締結される本サービスの利用契約をいいます。
      </p>
      <p class="l-terms__indent2">
        （8）個人情報<br>
        本サービスの提供に際して当社が知り得た個人に関する情報であって、当該情報に含まれる氏名、生年月日その他の記述により特定の個人を識別することができるもの（他の情報と容易に照合することができ、それにより特定の個人を識別できることとなるものを含む。）をいいます。
      </p>
    </div>

    <h3>第3条（本規約等の遵守）</h3>
    <div class="l-terms__block">
      <p class="l-terms__indent">1. 利用者は、本サービスの利用にあたり、本規約その他当社が本サービスに関して定める規則（これらも本規約に含むものとします。）を遵守しなければなりません。</p>
      <p class="l-terms__indent">2. 前項のほか、利用者は、本サービスを利用するにあたり、AWS利用規約に同意し、これを遵守しなければなりません。</p>
    </div>

    <h3>第4条（本規約の制定・変更）</h3>
    <div class="l-terms__block">
      <p class="l-terms__indent">1. 本規約の制定日以前に契約者と当社の間で締結された本サービスの利用契約その他の本サービスに関する合意事項は、契約者と当社の間で別段の合意がない限り、契約者が本規約に同意した時点ですべて失効し、以後本規約が適用されるものとします。</p>
      <p class="l-terms__indent">2. 当社は、法令に従い、本規約を随時変更することができます。この場合、利用者の利用条件その他サービス利用契約の内容は、変更の効力発生日から変更後の本規約に従うものとします。</p>
      <p class="l-terms__indent">3. 前項の変更を行う場合、当社は、書面または電子メールを送付する方法により、本規約を変更する旨および変更後の利用規約の内容ならびに変更の効力発生日を利用者に通知するものとします。</p>
    </div>

    <h2>第2章　利用契約</h2>
    <h3>第5条（利用契約の申込み）</h3>
    <div class="l-terms__block">
      <p class="l-terms__indent">1. 本サービスの利用を希望する法人または個人事業主（以下「申込者」といいます。）は、当社所定の方法により、申込みをするものとします。</p>
      <p class="l-terms__indent">2. 当社は、本規約および当社の基準に沿って前項の申込みを審査し、本サービスの利用を承諾する場合、その旨を申込者に通知します。利用契約は、当社がその申込を承諾する通知を発した時に成立し、当該承諾通知の発送日を利用開始日とします。</p>
    </div>

    <h3>第6条（利用契約を締結しない場合）</h3>
    <div class="l-terms__block">
      <p>申込者が以下の各号のいずれかの事由に該当する場合、前条の申込を承諾しない事があります。この場合、当社および販売代理店は、申込を承諾しない理由について開示する義務を負いません。</p>
      <p class="l-terms__indent2">（1）申込者が虚偽の事実を申告したとき</p>
      <p class="l-terms__indent2">（2）申込者が本サービスの利用に係る料金の支払いを怠るおそれがあるとき</p>
      <p class="l-terms__indent2">（3）本サービスの提供が技術上困難なとき</p>
      <p class="l-terms__indent2">（4）申込者が過去に本規約または当社との契約に違反したことがあるとき</p>
      <p class="l-terms__indent2">（5）第22条の反社会的勢力に該当し、またはその疑いがあるとき</p>
      <p class="l-terms__indent2">（6）その他当社が不適当と判断したとき</p>
    </div>

    <h3>第7条（利用料金等）</h3>
    <div class="l-terms__block">
      <p class="l-terms__indent">1. 契約者は、本サービスの利用対価として、当社が別途定める料金表に基づく料金（以下「本サービス料金」といいます。）を、別途当社と契約者の間で定める支払期限までに、当社が指定する方法により当社に支払うものとします。</p>
      <p class="l-terms__indent">2. 本サービス料金の支払方法が当社所定の金融機関口座への振込みである場合、振込手数料は契約者の負担とします。</p>
      <p class="l-terms__indent">3. 契約者が支払期限までに本サービス料金およびこれにかかる消費税等相当額を支払わない場合、当社は契約者に対し、支払期限の翌日から完済日までの日数に応じ、本サービス料金および消費税等相当額に対し年利14.6％を乗じて計算した金額、ならびに未払い金額を回収するために発生した合理的な弁護士費用を含むすべての費用を支払遅延損害金として請求することができます。</p>
    </div>

    <h3>第8条（利用期間）</h3>
    <div class="l-terms__block">
      <p class="l-terms__indent">1. 利用契約の有効期間（本サービスの利用期間）は、利用開始日から1年間とします。ただし、初年度は利用開始日から翌年3月末日までとします。</p>
      <p class="l-terms__indent">2. 期間満了2か月前までに、契約者または当社からの別段の申し入れがないときは、利用契約は自動的にさらに1年間更新されるものとし、以後も同様とします。</p>
    </div>

    <h3>第9条（契約者からの解約）</h3>
    <div class="l-terms__block">
      <p>契約者は、利用契約を解約しようとするときは、当社に対して、解約希望日の30日前までに、当社所定の方法により本サービスを解約する旨の通知を行うことにより、利用契約を解約することができます。ただし、解約理由、解約時期のいかんを問わず、既に契約者が当社に支払った本サービス料金の契約者への払い戻しは行われず、また、契約者は、利用契約の有効期間満了までの残存期間分の本サービス料金の支払いを免れません。</p>
    </div>

    <h3>第10条（当社からの解約）</h3>
    <div class="l-terms__block">
      <p class="l-terms__indent">1. 当社は、契約者が次の各号のいずれかに該当した場合、催告を要せず、利用契約の全部または一部を解除することができます。</p>
      <p class="l-terms__indent2">（1）利用契約または本規約に違反し、当社が是正の催告を行ったにもかかわらず、5営業日以内に当該違反が是正されなかった場合</p>
      <p class="l-terms__indent2">（2）支払停止または支払不能に陥った場合</p>
      <p class="l-terms__indent2">（3）手形または小切手が不渡りになった場合</p>
      <p class="l-terms__indent2">（4）差押え、仮差押え、仮処分もしくは競売の申立てがあった場合、または公租公課の滞納処分を受けた場合</p>
      <p class="l-terms__indent2">（5）破産手続開始、会社更生手続開始、民事再生手続開始または特別清算手続開始の申立てがあった場合</p>
      <p class="l-terms__indent2">（6）財務状態が著しく悪化し、またはそのおそれがあると認められる場合</p>
      <p class="l-terms__indent2">（7）監督官庁または所属団体から営業の取消し、停止等の処分を受けた場合</p>
      <p class="l-terms__indent2">（8）利用契約の継続を困難とする重大な事由が発生した場合</p>
      <p class="l-terms__indent">2. 契約者は、前項に基づき当社が本契約を解約した場合、当然に全債務の期限の利益を喪失し、ただちに債務全額を当社に支払わなければなりません。</p>
      <p class="l-terms__indent">3. 第1項に基づく解約時における本サービス料金の取扱いについては、前条ただし書を準用するものとします。</p>
    </div>

    <h3>第11条（変更通知）</h3>
    <div class="l-terms__block">
      <p class="l-terms__indent">1. 契約者は、その商号もしくは名称、本店所在地もしくは住所、連絡先その他契約者に関する重要事項に変更があるときは、当社所定の方法により遅滞なく当社に通知しなければなりません。</p>
      <p class="l-terms__indent">2. 当社は、契約者が前項に従った通知を怠ったことにより契約者が通知の不到達その他の事由により損害を被った場合であっても、一切責任を負いません。</p>
    </div>


    <h2>第3章　本サービスの利用</h2>

    <h3>第12条（顧客による利用）</h3>
    <div class="l-terms__block">
      <p class="l-terms__indent">1. 契約者は、利用契約の有効期間中に限り、OSアカウントを顧客に付与し（付与数の制限はありません。）、本サービスを利用させることができます。</p>
      <p class="l-terms__indent">2. 前項の場合における、本サービスの利用対価、利用期間その他の条件は、契約者と顧客の間で定めるものとします。ただし、利用契約、本規約またはAWS利用規約に違反・抵触する条件を定めることはできません。</p>
      <p class="l-terms__indent">3. 理由のいかんを問わず利用契約が終了した場合、顧客は、その時点で本サービスを利用する権利を当然に失うものとします。</p>
      <p class="l-terms__indent">4. 契約者は、顧客に対し、本規約およびAWS利用規約に定める事項を遵守させるものとし、顧客による本サービスの利用に関して、当社に対し自らが一切の責任を負うものとします。</p>
      <p class="l-terms__indent">5. 本サービスの利用に関する契約者と顧客の間のトラブルについては、両者の間で処理解決するものとし、当社は一切の責任を負いません。</p>
    </div>

    <h3>第13条（認証情報の管理）</h3>
    <div class="l-terms__block">
      <p class="l-terms__indent">1. 利用者は、当社から付与されたOSアカウント等の認証情報を、第三者に開示せず、貸与もしくは共有してはなりません。また、利用者は、認証情報の漏洩や紛失が生じないよう厳重に管理しなければなりません。</p>
      <p class="l-terms__indent">2. 利用者は、認証情報につき漏洩、紛失、または不正利用があったときは、速やかに当社に届け出るものとします。</p>
      <p class="l-terms__indent">3. 所定の認証情報によって本サービスにアクセスされている限り、利用者自身による利用とみなすものとし、第三者によって不正使用がなされた場合も、当社は何ら責任を負いません。</p>
    </div>

    <h3>第14条（サービスの中断・停止）</h3>
    <div class="l-terms__block">
      <p class="l-terms__indent">1. 当社は、次の各号のいずれかに該当する場合には、利用者への事前の通知・承諾を要することなく、本サービスの提供を中断することができます。</p>
      <p class="l-terms__indent2">（1）本サービスに関するシステムの不具合等により保守を行う場合</p>
      <p class="l-terms__indent2">（2）運用上または技術上の理由でやむを得ない場合</p>
      <p class="l-terms__indent2">（3）その他天災地変等不可抗力により本サービスを提供できない場合</p>
      <p class="l-terms__indent">2. 当社は、本サービスに関するシステムの定期点検を行うため、利用者に事前に通知の上、本サービスの提供を一時的に中断することができます。</p>
      <p class="l-terms__indent">3. 当社は、契約者が第10条（当社からの解約）第1項各号のいずれかに該当する場合もしくは契約者が本サービス料金の支払いを怠った場合または利用者が本規約に違反した場合には、事前の通知もしくは催告を要することなく本サービスの全部または一部の提供を停止することができます。</p>
      <p class="l-terms__indent">4. 当社は、前各項に定める事由のいずれかにより本サービスを提供できなかったことに関して利用者または第三者が損害を被った場合であっても、一切の責任を負いません。</p>
    </div>

    <h3>第15条（サービスの変更・廃止）</h3>
    <div class="l-terms__block">
      <p class="l-terms__indent">1. 当社は、本サービスの提供、運営に関するシステムや本サービスの仕様・内容の変更が必要であると判断した場合には、事前の通知を要することなくこれらを変更することができます。</p>
      <p class="l-terms__indent">2. 当社は、本サービスの全部または一部を廃止することができます。この場合、当社は、廃止日の60日前までに契約者に通知するものとし、廃止日をもって利用契約は当然に終了するものとします。ただし、天災地変等の不可抗力を理由に本サービスの全部または一部を廃止する場合には、当社が契約者に通知した日をもって廃止日とします。</p>
    </div>

    <h3>第16条（知的財産権の帰属）</h3>
    <div class="l-terms__block">
      <p class="l-terms__indent">1. 本サービスにおいて当社が使用する、プログラム、データベース、レイアウト、ならびに、画像、映像、文章および他のコンテンツに関する著作権、特許権、ノウハウ、およびほか一切の知的財産権は、当社または当該知的財産権の所有者であるライセンサーに帰属します。</p>
      <p class="l-terms__indent">2. 利用者は、本サービスの本来の用途に従って、本サービスのユーザとしての通常の利用方法によってのみ前項の知的財産を利用することができるにすぎず、いかなる方法でも、当社の事前の書面による許諾を得ずに、これらを複製やリバースエンジニアリング、再使用許諾等をすることはできません。</p>
    </div>

    <h3>第17条（免責事項）</h3>
    <div class="l-terms__block">
      <p class="l-terms__indent">1. 本サービスの各機能は、本サービスの提供時点において、「現状」のまま当社が提供可能なものであり、当社は利用者に対し、本サービスが利用者の特定の目的に適合すること、第三者の権利の非侵害保証を含め、本サービスに関する何らの保証を行いません。</p>
      <p class="l-terms__indent">2. 天災地変、戦争・内乱・暴動、法令の改廃・制定、公権力による命令・処分、労働争議、輸送機関・通信回線の事故、原材料・運賃の高騰、為替の大幅な変動その他当社の責めに帰すことのできない不可抗力による本サービス提供の全部または一部の履行遅延、履行不能または不完全履行については、当社は責任を負いません。</p>
      <p class="l-terms__indent">3. 本サービスの利用に関し、利用者が自己の責に帰すべき事由により第三者に損害を与えた場合または第三者からクレームを受けた場合等第三者との間でトラブルになった場合、利用者は自らの責任と費用をもって処理解決するものとし、当社は一切の責任を負いません。</p>
      <p class="l-terms__indent">4. 利用者は、自己の責任と費用において、本サービス利用のために必要な環境を準備・維持するものとし、利用者の設備の障害やインターネット接続サービスの不具合等の接続環境の障害等が発生した場合でも、当社は一切の責任を負いません。</p>
      <p class="l-terms__indent">5. 当社による善良なる管理者の注意をもってしても防御し得ない、本サービスへの予期しない不正アクセス等の行為によって利用者に損害が発生した場合、当社は一切の責任を負いません。</p>
      <p class="l-terms__indent">6. 債務不履行責任、不法行為責任その他請求原因のいかんを問わず、本サービスの利用に関し、当社が契約者に対して負う損害賠償責任の範囲は、当社の故意もしくは重大な過失により契約者が直接かつ現実に被った損害に限定され、かつ損害賠償の額は、契約者が当社に支払った1年間の本サービス料金相当額を上限とします。</p>
      <p class="l-terms__indent">7. 当社はいかなる場合であっても、顧客に対し、直接責任を負うことはありません。</p>
    </div>

    <h3>第18条（再委託）</h3>
    <div class="l-terms__block">
      <p>当社は、本サービスの提供に係る作業の全部または一部を第三者に再委託することがあります。この場合、当社は、再委託先に対して適切な監督を行うものとします。</p>
    </div>

    <h3>第19条（禁止事項）</h3>
    <div class="l-terms__block">
      <p>利用者は、本サービスの利用にあたり、次の各号に定める行為を行ってはなりません。</p>
      <p class="l-terms__indent2">（1）当社もしくは第三者の著作権、商標権等の知的財産権を侵害する行為、または、侵害するおそれのある行為</p>
      <p class="l-terms__indent2">（2）当社もしくは第三者の財産、プライバシーもしくは肖像権を侵害する行為、または、侵害するおそれのある行為</p>
      <p class="l-terms__indent2">（3）当社もしくは第三者を差別もしくは誹謗中傷・侮辱し、第三者への差別を助長し、または、当社もしくは第三者の名誉もしくは信用を毀損する行為</p>
      <p class="l-terms__indent2">（4）詐欺、規制薬物の濫用、児童売買春、預貯金口座および携帯電話の違法な売買等の犯罪に結びつく行為、または結びつくおそれの高い行為</p>
      <p class="l-terms__indent2">（5）わいせつ、児童ポルノまたは児童虐待に相当する画像、文書等を送信もしくは掲載する行為、またはこれらを収録した媒体を販売する行為、または、その送信、掲載、販売を想起させる広告を表示または送信する行為</p>
      <p class="l-terms__indent2">（6）ストーカー行為等の規制等に関する法律に違反する行為</p>
      <p class="l-terms__indent2">（7）無限連鎖講(ネズミ講)を開設し、または、これを勧誘する行為</p>
      <p class="l-terms__indent2">（8）違法行為(けん銃等の譲渡、児童ポルノの提供、公文書偽造、殺人、脅迫等)を直接的かつ明示的に請負し、仲介しまたは誘引(他人に依頼することを含む)する行為</p>
      <p class="l-terms__indent2">（9）違法に賭博・ギャンブルを行い、または、これを勧誘する行為</p>
      <p class="l-terms__indent2-2">（10）人の殺害現場等の残虐な情報、動物を虐待する画像等の情報、その他社会通念上第三者に著しく嫌悪感を抱かせる情報を掲載し、または、不特定多数の者にあてて送信する行為</p>
      <p class="l-terms__indent2-2">（11）人を自殺に誘引または勧誘する行為</p>
      <p class="l-terms__indent2-2">（12）インターネット異性紹介事業を利用して児童を誘引する行為の規制等に関する法律に基づく、当該事業の提供者に対する規制および当該事業を利用した不正勧誘行為の禁止に違反する行為</p>
      <p class="l-terms__indent2-2">（13）選挙の事前運動、選挙運動またはこれらに類似する行為および公職選挙法に抵触する行為</p>
      <p class="l-terms__indent2-2">（14）当社もしくは第三者に対し、無断で広告・宣伝・勧誘等の電子メールを送信する行為、嫌悪感を抱くもしくはそのおそれ がある電子メール (嫌がらせメール)を送信する行為、当社もしくは第三者の電子メール受信を妨害する行為、または連鎖的な電子メール転送を依頼する行為および当該依頼に応じて転送する行為</p>
      <p class="l-terms__indent2-2">（15）第三者の保有するコンピュータに対して多数回の接続行為を繰り返し行い、もって当該コンピュータを利用困難な状態におく行為</p>
      <p class="l-terms__indent2-2">（16）本人の同意を得ることなく、または、詐欺的な手段により第三者の個人情報を収集する行為</p>
      <p class="l-terms__indent2-2">（17）クラウドサービスの利用により利用しうる情報を改ざんまたは消去する行為</p>
      <p class="l-terms__indent2-2">（18）当社または第三者になりすましてクラウドサービスを利用する行為</p>
      <p class="l-terms__indent2-2">（19）当社もしくは第三者の設備等の利用、運営に支障を与える行為(クラウドサービスに格納された基本ソフトウェアの消去等、コンピュータの機能を破壊する行為を含む)、または、与えるおそれのある行為</p>
      <p class="l-terms__indent2-2">（20）有害なコンピュータプログラム等を送信もしくは掲載し、または、第三者が受信可能な状態におく行為</p>
      <p class="l-terms__indent2-2">（21）法令に基づき監督官庁等への届出、許認可の取得等の手続が義務づけられている場合に、当該手続を履行せず、その他当該法令に違反する行為</p>
      <p class="l-terms__indent2-2">（22）上記各号の他、法令もしくは公序良俗に違反(暴力、残虐等)する行為、当社の信用を毀損し、もしくは、当社の財産を侵害する行為、または、当社もしくは第三者に損害・不利益を与える行為</p>
      <p class="l-terms__indent2-2">（23）上記各号のいずれかに該当する行為(当該行為を第三者が行っている場合を含む)が見られるデータ等へリンクを張る行為</p>
      <p class="l-terms__indent2-2">（24）第三者に、前各号までのいずれかに該当する行為をなさしめ、または、当該第三者の当該行為が存在することを知りながら適切な措置を講じることなく放置する行為</p>
      <p class="l-terms__indent2-2">（25）その他当社が不適切と判断した行為</p>
    </div>

    <h2>第4章　その他</h2>

    <h3>第20条（機密保持）</h3>
    <div class="l-terms__block">
      <p class="l-terms__indent">1. 利用者および当社は、本サービスの提供に関連して相手方から資料、電磁的記録媒体その他の有形な媒体により提供された個人情報以外の情報であって、相手方から秘密である旨を明記されて受領したもの（以下「秘密情報」といいます。）について、善良なる管理者の注意をもってその秘密を保持するものとし、第三者に秘密情報を開示または漏洩してはなりません。</p>
      <p class="l-terms__indent">2. 前項の定めにかかわらず、次の各号の一に該当する資料および情報は、秘密情報に含まれません。</p>
      <p class="l-terms__indent2">（1）開示の時に既に公知のもの、または開示後被開示者の責に帰することのできない事由により公知となったもの</p>
      <p class="l-terms__indent2">（2）開示の時に被開示者が既に保有しているもの</p>
      <p class="l-terms__indent2">（3）被開示者が秘密保持義務を負うことなく第三者から適法に入手したもの</p>
      <p class="l-terms__indent2">（4）相手方から書面により開示を承諾されたもの</p>
      <p class="l-terms__indent2">（5）秘密情報によらずに独自に開発したもの</p>
      <p class="l-terms__indent">3. 利用者および当社は、秘密情報を本サービスの提供・利用の目的以外の目的で使用してはなりません。</p>
      <p class="l-terms__indent">4. 利用者および当社は、本サービスの提供・利用の目的のために必要な範囲で秘密情報を自己の役員および従業員ならびに弁護士、公認会計士等法令上当然に守秘義務を負う専門家（以下総称して「従業員等」といいます。）に開示することができます。この場合、利用者および当社は、本条に基づき自己に課された秘密保持義務と同等の義務を当該従業員等に課すものとします。</p>
      <p class="l-terms__indent">5. 第1項の規定にかかわらず、利用者および当社は、法令または裁判所、監督官庁、金融商品取引所その他受領者を規制する権限を有する公的機関の裁判、規則もしくは命令等により秘密情報の開示を要求された場合、秘密情報を必要最小限の範囲で開示することができます。ただし、利用者および当社は、当該開示を行うにあたり、可能な限り事前に、不可能または著しく困難な場合は事後遅滞なく、その旨を相手方に対して通知しなければなりません。</p>
      <p class="l-terms__indent">6. 利用者および当社は、本契約が終了した場合または本契約の有効期間中に相手方から要求があった場合には、相手方の指示に従い、秘密情報を速やかに開示者に返還もしくは返却または破棄もしくは消去しなければなりません。</p>
      <p class="l-terms__indent">7. 利用者および当社は、相手方から提供を受けた秘密情報を、本サービスを提供・利用するために必要な範囲に限り使用、複製することができます。また、秘密情報の改変が必要なときは、事前に相手方から書面による承諾を得るものとします。</p>
      <p class="l-terms__indent">8. 本条に定める秘密保持義務は、当該秘密情報の受領後5年間継続するものとします。</p>
      <p class="l-terms__indent">9. 利用者は、本サービスの利用に関し、AWS社から直接AWS社の秘密情報を入手した場合、AWS利用規約に従って当該情報を取り扱うものとします。</p>
    </div>

    <h3>第21条（個人情報の取り扱い）</h3>
    <div class="l-terms__block">
      <p>当社は、当社が別途定めるプライバシーポリシーに基づき個人情報を取り扱うものとします。</p>
    </div>

    <h3>第22条（反社会的勢力の排除）</h3>
    <div class="l-terms__block">
      <p class="l-terms__indent">1. 利用者および当社は相手方に対し、現在、次の各号のいずれにも該当しないことを表明し、かつ将来にわたっても該当しないことを確約します。</p>
      <p class="l-terms__indent2">（1）自己（契約者においては顧客も含みます。以下本項において同じです。）または自己の役員が、暴力団、暴力団員、暴力団関係企業・団体または暴力団関係者、総会屋、その他の反社会的勢力（以下「反社会的勢力」と総称します。）であること</p>
      <p class="l-terms__indent2">（2）自己または自己の役員が、反社会的勢力を利用すること</p>
      <p class="l-terms__indent2">（3）自己または自己の役員が、反社会的勢力に対して資金等を提供し、または便宜を供与するなど反社会的勢力の維持運営に協力し、または関与すること</p>
      <p class="l-terms__indent2">（4）自己または自己の役員が、反社会的勢力と社会的に非難されるべき関係を有していると認められること</p>
      <p class="l-terms__indent2">（5）自らまたは第三者を利用して、相手方に対し暴力的行為、詐術、脅迫的言辞を用い、相手方の名誉や信用を毀損し、また、相手方の業務を妨害すること</p>
      <p class="l-terms__indent2">（6）自らまたは第三者を利用して、相手方に対し法的な責任を超えた不当な要求行為を行うこと</p>
      <p class="l-terms__indent">2. 契約者および当社は、相手方が前項の確約に違反して、前項各号の一に該当することが判明した場合、相手方に対し何らの催告をすることなく、利用契約を解除することができます。この場合、解除された当事者は当該解除により損害を被った場合であっても、解除した当事者に対し何らの請求を行うことができません。</p>
    </div>

    <h3>第23条（損害賠償）</h3>
    <div class="l-terms__block">
      <p>利用者は、本サービスの利用に関し、自己（契約者においては顧客も含みます。）の責に帰すべき事由により当社に損害を与えた場合、当社に対して当該損害を賠償する責任を負うものとします。</p>
    </div>

    <h3>第24条（通知）</h3>
    <div class="l-terms__block">
      <p class="l-terms__indent">1. 当社は、本サービスに関して契約者に通知すべき事項が生じた場合には、書面または電子メールの送付その他当社が適当と判断する方法により、契約者に対し通知します。</p>
      <p class="l-terms__indent">2. 前項の通知は、当社が書面または電子メールを発信した時点のいずれか早い時点から効力を生ずるものとします。</p>
      <p class="l-terms__indent">3. 契約者が当社に提供した情報に誤りや記入漏れがあり、通知が到達しない場合、これにより契約者が損害を被ったとしても、当社は一切の責任を負いません。</p>
    </div>

    <h3>第25条（譲渡禁止）</h3>
    <div class="l-terms__block">
      <p>契約者および当社は、利用契約上の地位ならびに利用契約に基づく自己の権利および義務の全部または一部を、相手方の事前の書面による承諾を得ることなく第三者に譲渡または貸与してはなりません。</p>
    </div>

    <h3>第26条（分離条項）</h3>
    <div class="l-terms__block">
      <p>本規約のいずれかの条項またはその一部が、法令等により無効または執行不能と判断された場合であっても、本契約の残りの規定および残りの部分は、継続して完全に効力を有するものとします。</p>
    </div>

    <h3>第27条（準拠法）</h3>
    <div class="l-terms__block">
      <p>本規約および利用契約に関する準拠法は、日本法とします。</p>
    </div>

    <h3>第28条（合意管轄）</h3>
    <div class="l-terms__block">
      <p>本規約および利用契約に関する訴訟は、東京地方裁判所を第一審の専属的合意管轄裁判所とします。</p>
    </div>

    <p class="l-terms__mtop">2023年4月1日制定</p>



  </div>
</template>

<script>

export default {
  data() {
    return {
      scrolled: false,
    }
  },
  created: function () {
    window.addEventListener("scroll", this.handleScroll);
  },
  mounted: function () {
    let terms = document.getElementById('terms');
    terms.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      let terms = document.getElementById('terms');
      let scrollHeight = terms.scrollHeight;
      let scrollPosition = terms.offsetHeight + terms.scrollTop;
      if ((scrollHeight - scrollPosition) / scrollHeight <= 0.01) {
        this.$emit('done-scrolled');
      }
    },
  },
}

</script>
